import React from 'react'
import HeroSection from './HeroSection'
import ProfessionalSummary from './ProfessionalSummary'

import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { Box, Button } from '@mui/material';
import ProfessionalExperience from './ProfessionalExperience';
import SkillsExpertise from './SkillsExpertise';
import Academic from './Academic';
import Acossiations from './Acossiations';
import RecommendationCTA from './RecommendationCTA';
import Footer from './Footer';
const downloadPDF = async () => {
  const input = document.getElementById("resume-container");
  if (!input) return;

  // Fix width to avoid responsive shifting
  input.style.width = "1400px";

  const canvas = await html2canvas(input, {
    scale: 2,
    useCORS: true,
    backgroundColor: "#ffffff",
    scrollY: -window.scrollY,
  });

  const imgData = canvas.toDataURL("image/png");

  const pdf = new jsPDF({
    orientation: "portrait",
    unit: "mm",
    format: "a4",
  });

  const pdfWidth = 210;
  const pdfHeight = 297;

  const imgWidth = pdfWidth;
  const imgHeight = (canvas.height * pdfWidth) / canvas.width;

  // If height is bigger than A4, scale down
  const finalHeight =
    imgHeight > pdfHeight ? pdfHeight : imgHeight;

  const finalWidth =
    imgHeight > pdfHeight
      ? (canvas.width * pdfHeight) / canvas.height
      : pdfWidth;

  const x = (pdfWidth - finalWidth) / 2;
  const y = (pdfHeight - finalHeight) / 2;

  pdf.addImage(imgData, "PNG", x, y, finalWidth, finalHeight);

  pdf.save("Rajiv-Williams-Resume.pdf");

  input.style.width = "100%";
};

const index = () => {
  return (
    <Box>

    <div id="resume-container">
       
        <HeroSection/>
        <ProfessionalSummary/>
        <ProfessionalExperience/>
        <SkillsExpertise/>
        <Academic/>
        <Acossiations/>
        <RecommendationCTA/>
        <Footer/>
    </div>
     {/* <Button
  variant="contained"
  onClick={downloadPDF}
  sx={{
    backgroundColor: "#0f63a5",
    textTransform: "none",
  }}
>
  Download Resume
</Button> */}
    </Box>
  )
}

export default index